import { render, staticRenderFns } from "./p05.vue?vue&type=template&id=01e78b85&scoped=true&"
import script from "./p05.vue?vue&type=script&lang=js&"
export * from "./p05.vue?vue&type=script&lang=js&"
import style0 from "./p05.vue?vue&type=style&index=0&id=01e78b85&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e78b85",
  null
  
)

export default component.exports